import Home from '@/components/home.vue';

function lazyLoad(view){
  return() => import(`@/components/${view}.vue`)
}

export default [
  { path: '/', component: Home },
  { path: '/menu', component: lazyLoad('menu') },
  { path: '/email', component: lazyLoad('email') },
  { path: '/dryGrittyEyes', component: lazyLoad('dryEyes') },
  
    { path: '/stuckInEye', component: lazyLoad('stuckInEye') },
    { path: '/wateryTearyEyes', component: lazyLoad('wateryTearyEyes') },
    
  { path: '/redEyes', component: lazyLoad('redEyes') },
  { path: '/swollenEyelids', component: lazyLoad('swollenEyelids') },
  { path: '/bulgingEyes', component: lazyLoad('bulgingEyes') },
  { path: '/eyelidRetraction', component: lazyLoad('eyelidRetraction') },
  { path: '/misAlignedEyes', component: lazyLoad('misAlignedEyes') },
  { path: '/sensitiveToLight', component: lazyLoad('sensitiveToLight') },
  { path: '/blurryVision', component: lazyLoad('blurryVision') },
  { path: '/doubleVision', component: lazyLoad('doubleVision') },
  { path: '/eyepainPressure', component: lazyLoad('eyepainPressure') },
  { path: '/lossOfVision', component: lazyLoad('lossOfVision') },
  { path: '/nextSteps', component: lazyLoad('nextSteps') },

];
